import React, { useEffect, useRef, useState } from 'react';
import withLayout from '../../common/layout';
import { AddNewBtn, ButtonRow, ChannelPreview, CustomizeBox, FormGroup, Header, Input, Label, PreviewBox, PreviewCard, PrimaryBtn, SecondaryBtn, Section, SectionTitle, Select, SettingsPanel, SettingsTab, SettingsTabs, Switch, Tab, Tabs, Textarea, ToggleRow, TopBar,TabList, SubTabs, Panel, DangerBtn, CopyBtn, LinkBox, Description, Customize, GreenBtn, GrayBox, GrayLine, Preview,ChannelRow, SubTab, PageContainer, PreviewBtn, PrefixSpan, Poster, Preview2, SelectHeader  } from './styles';
import { Container } from '../../common/layout/styels';
import { AddIcon, DeleteIcon, GetIcon } from '../../../../icons';
import { useTranslation } from 'react-i18next';
import { Logo, Title } from '../../common/layout/header/styels';
import { AddButton } from '../../../elements/list/styles';
import CustomSelect from '../../../elements/select';
import FormInput from '../../../elements/input';
import { logo } from '../../../../images';
import { SketchPicker } from "react-color";
import { Button } from '../../../elements/select/styles';
import {QRCodeSVG} from "qrcode.react";
import { v4 as uuidv4 } from 'uuid';
import { Footer, FormMainContainer, Overlay, Page } from '../../../elements/list/create/styles';
import { CloseButton } from '../../../elements/list/popup/styles';
import { Header as TopHeader } from "../../../elements/list/manage/styles";
import MultiSelect from '../../../elements/multiSelect';
import { bulkUploadData, deleteData, getData, postData, putData } from '../../../../backend/api';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../elements/loader';
import FormFieldsManager from './FormFieldsManager';

const ReportingChannel = (props) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [defaultPrimaryColor] = useState('#3Fc4FD');
  const [defaultElementCorners] = useState('0px');
  const [defaultButtonCorners] = useState('0px');
  const [isAddNew, setIsAddNew] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('Default');
  const [activeSettingsTab, setActiveSettingsTab] = useState('settings');
  const [isUpdate, setIsUpdate] = useState(false);
  const tabsRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);


  const [submitDisabled, setSubmitDisabled] = useState(true);

  const [formData, setFormData] = useState([{
    channelId: '9ff45724-9d86-4f2d-8f09-4ec1e6aa1c99',
    channelName: 'Default',

    anonymity: 'allow-selection',
    allowFileUpload: true,

    showCaseHandlerInfo: true,
    showCaseHandlerNameInMessages: false,

    showCategories: true,
    showStatus: true,
    showCaseSeverity: false,
    showAssignedCaseHandler: false,

    disableReporterMsgAftClosing: false,

    department: [],
    category: [],

    emailForNotification: 'always',
    multipleDepartmentSelection: 'false',
    channelLogo: '',
    primaryColor: defaultPrimaryColor,
    elementCorners: defaultElementCorners,
    buttonCorners: defaultButtonCorners

  }]);

  useEffect(() => {
    const checkOverflow = () => {
      if (tabsRef.current) {
        const { scrollWidth, clientWidth } = tabsRef.current;
        setIsOverflowing(scrollWidth > clientWidth);
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);

    return () => window.removeEventListener("resize", checkOverflow);
  }, [formData]);


  const [activeChannel, setActiveChannel] = useState(formData[0]);

  useEffect(() => {
      document.title = `${t("reporting-channel")} - Whistleblower24`;
    }, []);

  useEffect(() => {
    fetchChannels()
  }, [])


  const fetchChannels = async (refetch=false) => {
    try {
      setIsLoading(true);
        await getData({ }, "channel", dispatch, navigate)
      .then((response) => {
        setIsLoading(false);
        setFormData(response.data.data)
        if(!refetch && Array.isArray(response.data.data) && response.data.data.length > 0)
          setActiveChannel(response.data.data[0]);

        setIsUpdate(false);
  
      })
      .catch((error) => {
        setIsLoading(false)
        console.log(error);
        
      });
      } catch (error) {
        setIsLoading(false)
        console.log(error);
        
      }
  }

  // console.log("dcchay guhhbdj", activeChannel, formData)

  const createChannel = async () => {
    try {
      setIsLoading(true);
        await postData(newData, "channel", dispatch, navigate)
      .then((response) => {
        setIsLoading(false);
        fetchChannels(true);
      })
      .catch((error) => {
        setIsLoading(false)
        console.log(error);
        
      });
      } catch (error) {
        setIsLoading(false)
        console.log(error);
        
      }
  }
  

  const handleChange = (index, event, name, type) => {

    const changes = { ...activeChannel };
    const allChannels = [...formData];
    const idx = allChannels.findIndex((ch) => ch.channelId === changes.channelId);

    if(type === 'image') {
      const file = event.target.files;
      changes[name] = file;
    } else {
      changes[name] = event.target.value;
    }

    setActiveChannel(changes);

    if (idx !== -1) {
      allChannels[idx] = changes;
      setFormData(allChannels);
    }

    setIsUpdate(true);

  };

  const handleSelect = (index, event, id, type) => {

    const changes = { ...activeChannel };

    if(type==="multiSelect"){
      if(changes[id] && changes[id].findIndex((val) => val===event.id) !== -1){
        const idx = changes[id].findIndex((val) => val===event.id);
        changes[id].splice(idx,1);
      } else if(changes[id] && changes[id].findIndex((val) => val===event.id) === -1){
        changes[id].push(event.id)
      } else {
        changes[id] = [event.id];
      }
    } else {
      changes[id] = event.id;
    }

    setActiveChannel(changes);

    const allChannels = [...formData];
    const idx = allChannels.findIndex((ch) => ch.channelId === changes.channelId);
    if (idx !== -1) {
      allChannels[idx] = changes;
      setFormData(allChannels);
    }

    setIsUpdate(true);

  };

  const handleToggle = (event) => {
    const { name, checked } = event.target;

    const changes = { ...activeChannel };
    changes[name] = checked;

    setActiveChannel(changes);

    const allChannels = [...formData];
    const idx = allChannels.findIndex((ch) => ch.channelId === changes.channelId);
    if (idx !== -1) {
      allChannels[idx] = changes;
      setFormData(allChannels);
    }

    setIsUpdate(true);
  }

  const handleChangeComplete = (newColor) => {
    const changes = { ...activeChannel };
    changes.primaryColor = newColor.hex;

    setActiveChannel(changes);

    const allChannels = [...formData];
    const idx = allChannels.findIndex((ch) => ch.channelId === changes.channelId);
    if (idx !== -1) {
      allChannels[idx] = changes;
      setFormData(allChannels);
    }

    setIsUpdate(true);
  };

  const [newData, setNewData] = useState({
    channelId: uuidv4(),
    channelName: '',

    anonymity: 'allow-selection',
    allowFileUpload: true,

    showCaseHandlerInfo: true,
    showCaseHandlerNameInMessages: false,

    showCategories: true,
    showStatus: true,
    showCaseSeverity: false,
    showAssignedCaseHandler: false,

    disableReporterMsgAftClosing: false,

    department: '',
    category: '',

    emailForNotification: 'always',
    multipleDepartmentSelection: 'false',
    channelLogo: '',
    primaryColor: defaultPrimaryColor,
    elementCorners: defaultElementCorners,
    buttonCorners: defaultButtonCorners
  }) 

  const closeModal = () => {
    setIsAddNew(false);
    setNewData({
      channelId: uuidv4(),
      channelName: '',

      anonymity: 'allow-selection',
      allowFileUpload: true,

      showCaseHandlerInfo: true,
      showCaseHandlerNameInMessages: false,

      showCategories: true,
      showStatus: true,
      showCaseSeverity: false,
      showAssignedCaseHandler: false,

      disableReporterMsgAftClosing: false,

      department: '',
      category: '',

      emailForNotification: 'always',
      multipleDepartmentSelection: 'false',
      channelLogo: '',
      primaryColor: defaultPrimaryColor,
      elementCorners: defaultElementCorners,
      buttonCorners: defaultButtonCorners
    });
    setSubmitDisabled(true);
  }

  const handleNewDataSubmit = (e) => {
    e.preventDefault();
    createChannel();
    setFormData([...formData, newData]);
    closeModal();
  }

  useEffect(() => {
    if(newData.channelId.trim() !== '' && newData.channelName.trim() !== ''){
      setSubmitDisabled(false);
    } else {
      setSubmitDisabled(true);
    }
  }, [newData])

  const handleDeleteChannel = async() => {
    try {
      if(formData.length >= 1) {
        setIsLoading(true);
          await deleteData({}, `channel`,activeChannel._id, dispatch, navigate)
        .then((response) => {
          setIsLoading(false);
          fetchChannels(false);
        })
        .catch((error) => {
          setIsLoading(false)
          console.log(error);
          
        });
      }
    } catch (error) {
      setIsLoading(false)
      console.log(error);
      
    }
  }

  const handleUpdate = async () => {
  try {
    console.log("updating channels", formData);
    setIsLoading(true);

    // Run all uploads in parallel
    const promises = formData.map((item) => 
      putData(item, `channel/${item._id}`, dispatch, navigate)
    );

    await Promise.all(promises);

    // Once all are done
    fetchChannels(true);
  } catch (error) {
    console.error("Error updating channels:", error);
  } finally {
    setIsLoading(false);
  }
};

  
  // if(isLoading){
  //   return <Loader/>
  // }

  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const textToCopy = `${process.env.REACT_APP_WHISTLEBLOWING_URL}/channel/${activeChannel.channelId}`;
    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500); // show green tick for 1.5s
      })
      .catch((err) => console.error("Copy failed:", err));
  };


  return (
    <>
    <Container style={{boxShadow: 'none'}} className="column">

        <Title className="inner">
            <GetIcon icon={"report"}></GetIcon>
            {t("reportingChannels")}
        </Title>

        <PageContainer>
      {/* Top Tabs */}
      <TopBar>
        <TabList>
          {/* <Tab active>Links</Tab>
          <Tab>Phone number</Tab>
          <Tab>Board</Tab> */}
        </TabList>
        <AddButton onClick={()=> setIsAddNew(true)} style={{marginLeft:0}}>
            <AddIcon></AddIcon>
            <span>{t("newReportingChannel")}</span>
        </AddButton>
      </TopBar>

      {/* Default / Test Tabs */}
      {!isOverflowing ? (
        <SubTabs ref={tabsRef}>
          {formData.map((channel) => (
            <SubTab
              key={channel.channelId}
              active={channel.channelId === activeChannel.channelId}
              onClick={() => setActiveChannel(channel)}
            >
              {channel.channelName}
            </SubTab>
          ))}
        </SubTabs>
      ) : (
        <SelectHeader>
          <CustomSelect id="channel" name="channel" label="" value={activeChannel.channelId} formValues={activeChannel} placeholder={t("None Selected")} apiType="JSON" selectApi={formData.map((channel) => ({id: channel.channelId, value: channel.channelName}))} onSelect={(index,e) => {
              if(!e.id) return;
              const selected = formData.find(
                (c) => c.channelId === e.id
              );
              setActiveChannel(selected);
            }} />
        </SelectHeader>
      )}

      {/* Channel Preview Section */}
      <ChannelRow>
        <Preview>
          <PreviewBox>
            <GrayLine />
            <GrayLine width="60%" />
            <GrayBox />
            <GrayLine width="60%" />
            <GrayLine />
            <div style={{ display: 'flex', gap: '12px'}}>
                <PreviewBtn color={activeChannel.primaryColor} borderColor={activeChannel.primaryColor} />
                <PreviewBtn borderColor={activeChannel.primaryColor} />
            </div>
          </PreviewBox>
        </Preview>
        <Customize>
          <Title style={{marginLeft: 0}}>{t("reporting-channel-customize-title")}</Title>
          <Description>
            {t("reporting-channel-customize-desc")}
          </Description>

          <LinkBox>
            <Input style={{width: '100%', whiteSpace:'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', borderTopRightRadius: 0, borderBottomRightRadius: 0}} value={`${process.env.REACT_APP_WHISTLEBLOWING_URL}/channel/${activeChannel.channelId}`} readOnly />
            <CopyBtn onClick={handleCopy}>
                {copied ? (
                  <GetIcon icon="correct" color="green" />
                ) : (
                  <GetIcon icon="copy" />
                )}
            </CopyBtn>
          </LinkBox>

          {/* <FormGroup>
            <Label>Default language</Label>
            <Select>
              <option>English</option>
              <option>German</option>
            </Select>
          </FormGroup> */}

          {/* <FormGroup>
            <Label>Page description</Label>
            <Textarea rows={3} placeholder="Enter description..." />
          </FormGroup> */}

          <ButtonRow >
            <a href={`${process.env.REACT_APP_WHISTLEBLOWING_URL}/channel/${activeChannel.channelId}`} target='_blank' ><PrimaryBtn style={{cursor: 'pointer'}}>{t("Open page")}</PrimaryBtn></a>
            <DangerBtn disabled={!formData || !Array.isArray(formData) || formData.length === 0 || formData.length === 1} onClick={handleDeleteChannel}> <DeleteIcon /> {t("Delete channel")}</DangerBtn>
          </ButtonRow>
        </Customize>
      </ChannelRow>

      {/* Settings Tabs */}
      <SettingsTabs>
        <SettingsTab active={activeSettingsTab === 'settings'} onClick={() => setActiveSettingsTab('settings')}>{t("settings")}</SettingsTab>
        <SettingsTab active={activeSettingsTab === 'forms'} onClick={() => setActiveSettingsTab('forms')}>{t("Form Fields")}</SettingsTab>
        <SettingsTab active={activeSettingsTab === 'posterBuilder'} onClick={() => setActiveSettingsTab('posterBuilder')}>{t("Poster builder")}</SettingsTab>
        <SettingsTab active={activeSettingsTab === 'customizeDesign'} onClick={() => setActiveSettingsTab('customizeDesign')}>{t("Customize design")}</SettingsTab>
      </SettingsTabs>

      {/* SETTINGS PANEL */}
      {activeSettingsTab==="settings" && <Panel>
        {/* Link settings */}
        <ChannelRow>
          <Preview2>
            <SectionTitle style={{margin: 0}}>{t("Link settings")}</SectionTitle>
            <Description>{t("Control basic settings for the channel such as name and url. The name is for internal use and cannot be seen by the whistleblower")}</Description>
          </Preview2>
          <Customize>
            <FormGroup>
              <Label>{t("name")}</Label>
              <Input value={activeChannel.channelName} onChange={(e) => handleChange(0, e, 'channelName', 'text')} placeholder={t("Enter channel name")} />
            </FormGroup>
            <FormGroup>
              <Label>{t("Link suffix")}</Label>
              <div style={{ display: 'flex'}}>
                  <PrefixSpan style={{display: 'inline-flex', backgroundColor: '#fbfbfbff', borderTopRightRadius: 0, borderBottomRightRadius: 0}} >{`${process.env.REACT_APP_WHISTLEBLOWING_URL}/channel/`}</PrefixSpan>
                  <Input style={{width: '100%', flex: 1, borderTopLeftRadius: 0, borderBottomLeftRadius: 0}} value={activeChannel.channelId} onChange={(e) => handleChange(0, e, 'channelId', 'text')} />
              </div>
            </FormGroup>
          </Customize>
        </ChannelRow>

        {/* Anonymity settings */}
        <ChannelRow>
          <Preview2>
            <SectionTitle style={{margin: 0}}>{t("Anonymity settings")}</SectionTitle>
            <Description>{t("Control if the whistleblower should be able to report anonymously and additional setting here")}</Description>
          </Preview2>
          <Customize>
            <FormGroup>
            <CustomSelect id="anonymity" name="anonymity" label={t("Hide and preselect the following choice of anonymity:")} value={activeChannel.anonymity} formValues={activeChannel} placeholder={t("None Selected")} apiType="JSON" selectApi={[{id: "allow-selection", value: t("Allow selection")},{id: "confidential", value: t("Confidential")}, {id: "anonymous", value: t("Anonymous")}]} onSelect={handleSelect} />
            </FormGroup>
            <ToggleRow style={{marginTop: '15px', paddingLeft: '5px'}}>
              <div>
                <Label>{t("Allow file upload")}</Label>
                <Description style={{margin: 0}}>{t("Allow users to upload files")}</Description>
              </div>
              <Switch name='allowFileUpload' checked={activeChannel.allowFileUpload} onChange={handleToggle} style={{minWidth: '40px'}} />
            </ToggleRow>
          </Customize>
        </ChannelRow>

        {/* Visibility settings */}
        <ChannelRow>
          <Preview2>
            <SectionTitle style={{margin: 0}}>{t("Visibility settings")}</SectionTitle>
            <Description>{t("Change which options are available in terms of categories or departments. If none are selected all will be available. If only one options is chosen, it will be selected automatically and hidden on the reporting page")}</Description>
          </Preview2>
          <Customize>
          <FormGroup>
            <MultiSelect type="multiSelect" id="department" name="department" label={t("Choose departments that should be selectable")} value={activeChannel.department} formValues={activeChannel} placeholder="None Selected" apiType="API" selectApi="department/select" onSelect={handleSelect} />
          </FormGroup>
          <FormGroup>
            <MultiSelect type="multiSelect" id="category" name="category" label="Choose categories that should be selectable" value={activeChannel.category} formValues={activeChannel} placeholder="None Selected" apiType="API" selectApi="whistle-category/select" onSelect={handleSelect} />
          </FormGroup>
        </Customize>
        </ChannelRow>

        {/* Case handler settings */}
        <ChannelRow>
          <Preview2>
            <SectionTitle style={{margin: 0}}>{t("Case handler settings")}</SectionTitle>
            <Description>{t("Settings regarding the case handlers and communication with the whistleblower")}</Description>
          </Preview2>
          <Customize>
          <ToggleRow>
            <div>
              <Label>{t("Show case handler information")}</Label>
              <Description style={{margin: 0}}>{t("If disabled, whistleblowers will not see case handler details when reporting.")}</Description>
            </div>
            <Switch name='showCaseHandlerInfo' checked={activeChannel.showCaseHandlerInfo} onChange={handleToggle} style={{minWidth: '40px'}} />
          </ToggleRow>
          <ToggleRow>
            <div>
              <Label>{t("Show case handler name in messages to whistleblower")}</Label>
              <Description style={{margin: 0}}>{t("If disabled, messages will appear as sent from 'Case handler' instead")}</Description>
            </div>
            <Switch name='showCaseHandlerNameInMessages' checked={activeChannel.showCaseHandlerNameInMessages} onChange={handleToggle} style={{minWidth: '40px'}} />
          </ToggleRow>
        </Customize>
        </ChannelRow>

        {/* Case details */}
        <ChannelRow>
          <Preview2>
            <SectionTitle style={{margin: 0}}>{t("Case details for whistleblowers")}</SectionTitle>
            <Description>{t("Select which case details whistleblowers can see in their reports.")}</Description>
          </Preview2>
          <Customize>
          <ToggleRow>
            <Label>{t("Show categories")}</Label>
            <Switch name='showCategories' checked={activeChannel.showCategories} onChange={handleToggle} style={{minWidth: '40px'}} />
          </ToggleRow>
          <ToggleRow>
            <div>
              <Label>{t("Show state")}</Label>
              <Description style={{margin: 0}}>{t("Display the current state of the case. If disabled, the whistleblower will only see when a case is closed")}</Description>
            </div>
            
            <Switch name='showStatus' checked={activeChannel.showStatus} onChange={handleToggle} style={{minWidth: '40px'}} />
          </ToggleRow>
          <ToggleRow>
            <Label>{t("Show case severity")}</Label>
            <Switch name='showCaseSeverity' checked={activeChannel.showCaseSeverity} onChange={handleToggle} style={{minWidth: '40px'}} />
          </ToggleRow>
          <ToggleRow>
            <Label>{t("Show assigned case handler")}</Label>
            <Switch name='showAssignedCaseHandler' checked={activeChannel.showAssignedCaseHandler} onChange={handleToggle} style={{minWidth: '40px'}} />
          </ToggleRow>
        </Customize>
        </ChannelRow>

        {/* Message Settings */}
        <ChannelRow>
          <Preview2>
            <SectionTitle style={{margin: 0}}>{t("Message settings")}</SectionTitle>
          </Preview2>
          <Customize>
          <ToggleRow>
            <div>
              <Label>{t("Disable reporter messages after closing the case")}</Label>
              <Description style={{margin: 0}}>{t("When enabled, reporters will not be able to send new messages once a case has been closed. Case handlers can still send messages to closed cases.")}</Description>
            </div>
            
            <Switch name='disableReporterMsgAftClosing' checked={activeChannel.disableReporterMsgAftClosing} onChange={handleToggle} style={{minWidth: '40px'}} />
          </ToggleRow>
        </Customize>
        </ChannelRow>

        {/* Miscellaneous settings */}
        <ChannelRow>
          <Preview2>
            <SectionTitle style={{margin: 0}}>{t("Miscellaneous settings")}</SectionTitle>
          </Preview2>
          <Customize>
          <FormGroup>
            <CustomSelect id="emailForNotification" name="emailForNotification" label="Allow whistleblower to submit email for notifications after reporting" value={activeChannel.emailForNotification} formValues={activeChannel} placeholder="None Selected" apiType="JSON" selectApi={[{id: "always", value: t("Always")},{id: "confidential", value: t("When Confidential")}, {id: "anonymous", value: t("When Anonymous")}, {id: "never", value: t("Never")}]} onSelect={handleSelect} />
          </FormGroup>
          <FormGroup>
            <CustomSelect id="multipleDepartmentSelection" name="multipleDepartmentSelection" label="Department selection type" value={typeof activeChannel.multipleDepartmentSelection === "boolean" ? String(activeChannel.multipleDepartmentSelection) : activeChannel.multipleDepartmentSelection } formValues={activeChannel} placeholder="None Selected" apiType="JSON" selectApi={[{id: "false", value: t("Single department")},{id: "true", value: t("Multiple departments")}]} onSelect={handleSelect} />
          </FormGroup>
        </Customize>
        </ChannelRow>
      </Panel>}

      {activeSettingsTab==="forms" && <Panel>
        <FormFieldsManager 
          channel={activeChannel} 
          dispatch={dispatch} 
          navigate={navigate}
          setLoaderBox={setIsLoading}
          setMessage={props.setMessage}
        />
      </Panel>}

      {activeSettingsTab==="customizeDesign" && <Panel>
        {/* Logo */}
        <ChannelRow>
          <Preview2>
            <SectionTitle style={{margin: 0}}>{t("Logo")}</SectionTitle>
            <Description>{t("Here you can upload a custom logo that will be displayed on the reporting page")}</Description>
          </Preview2>
          <Customize>
            <FormInput index={0} animation={`sub-1`} placeholder={"Change"} key={`input` + 0} id={"channelLogo"} formValues={activeChannel} error="" value={activeChannel.channelLogo} onChange={handleChange} type="image" name="channelLogo" />
            <div style={{marginTop: '10px', display: 'flex', alignItems: 'center', gap: '20px'}}>
              {activeChannel.channelLogo && <div style={{marginTop: '10px', paddingRight: '30px', borderRight: '2px solid grey'}}><img src={typeof activeChannel.channelLogo === "string" ? `${process.env.REACT_APP_CDN}${activeChannel.channelLogo}` : URL.createObjectURL(activeChannel.channelLogo[0])} alt="Logo Preview" style={{maxWidth: '200px', maxHeight: '100px'}} /></div>}
              <Logo src={logo} alt="logo" />
            </div>
          </Customize>
        </ChannelRow>

        {/* Color & style */}
        <ChannelRow>
          <Preview2>
            <SectionTitle style={{margin: 0}}>{t("Color & style")}</SectionTitle>
            <Description>{t("Change the primary colors and style of elements and buttons on the reporting page")}</Description>
          </Preview2>
          <Customize>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
              <Label>{t("Primary color")}</Label>
              <Button onClick={()=> {
                const changes = { ...activeChannel };
                changes.primaryColor = defaultPrimaryColor;

                setActiveChannel(changes);

                const allChannels = [...formData];
                const idx = allChannels.findIndex((ch) => ch.channelId === changes.channelId);
                if (idx !== -1) {
                  allChannels[idx] = changes;
                  setFormData(allChannels);
                }

                setIsUpdate(true);
              }} style={{fontSize: '16px', padding: '8px 15px', margin: 0}}>{t("Use default")}</Button>
            </div>
            <div style={{display: 'flex', justifyContent: 'center', width: '100%', margin: '20px 0'}}>
              <SketchPicker
                color={activeChannel.primaryColor}
                onChangeComplete={handleChangeComplete}
                presetColors={[
                  "#000000", "#FF5722", "#FF9800", "#FFC107",
                  "#4CAF50", "#2196F3", "#3F51B5", "#9C27B0",
                ]}
              />
            </div>
            <div>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                <Label>{t("Element corners")}</Label>
                <Button onClick={()=> {
                  const changes = { ...activeChannel };
                  changes.elementCorners = defaultElementCorners;

                  setActiveChannel(changes);

                  const allChannels = [...formData];
                  const idx = allChannels.findIndex((ch) => ch.channelId === changes.channelId);
                  if (idx !== -1) {
                    allChannels[idx] = changes;
                    setFormData(allChannels);
                  }

                  setIsUpdate(true);
                }} style={{fontSize: '16px', padding: '8px 15px', margin: 0}}>{t("Use default")}</Button>
              </div>
              <FormGroup>
                <CustomSelect id="elementCorners" name="elementCorners" value={activeChannel.elementCorners} formValues={activeChannel} placeholder="None Selected" apiType="JSON" selectApi={[{id: "0px", value: `${t("None")} (0px)`},{id: "5px", value: `${t("Small")} (5px)`}, {id: "8px", value: `${t("Medium")} (8px)`}, {id: "12px", value: `${t("Large")} (12px)`}]} onSelect={handleSelect} />
              </FormGroup>
            </div>
            <div>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                <Label>{t("Rounding of button")}</Label>
                <Button onClick={()=> {
                  const changes = { ...activeChannel };
                  changes.buttonCorners = defaultButtonCorners;

                  setActiveChannel(changes);

                  const allChannels = [...formData];
                  const idx = allChannels.findIndex((ch) => ch.channelId === changes.channelId);
                  if (idx !== -1) {
                    allChannels[idx] = changes;
                    setFormData(allChannels);
                  }

                  setIsUpdate(true);
                }} style={{fontSize: '16px', padding: '8px 15px', margin: 0}}>{t("Use default")}</Button>
              </div>
              <FormGroup>
                <CustomSelect id="buttonCorners" name="buttonCorners" value={activeChannel.buttonCorners} formValues={activeChannel} placeholder="None Selected" apiType="JSON" selectApi={[{id: "0px", value: `${t("None")} (0px)`},{id: "5px", value: `${t("Small")} (5px)`}, {id: "8px", value: `${t("Medium")} (8px)`}, {id: "12px", value: `${t("Large")} (12px)`}, {id: "100%", value: t("Full (Completly rounded)")}]} onSelect={handleSelect} />
              </FormGroup>
            </div>
          </Customize>
        </ChannelRow>

      </Panel>}

      {activeSettingsTab==="posterBuilder" && <Panel>
        <Title style={{margin: 0}}>{t("Employee awareness")}</Title>
        <Description style={{margin: 0, marginTop: '5px'}}>{t("One way to spread awareness is to hang up posters at the workplace. You can reach out to us if you are interested.")}</Description>
        
        <div style={{display: 'flex', gap: '10px', margin: '20px 0', fontSize:'18px', flexWrap: 'wrap'}}>
          <div>{t("Call us for more information:")}</div>
          <a style={{color: '#000', textDecoration: 'none', fontWeight: 600}} href="tel:+498131360180">{t("+49 8131 360180")}</a>
        </div>

        <div>{t("An example of what a poster could look like")}</div>

        <div style={{display: 'flex', justifyContent: 'center', width: '100%', margin: '30px 0'}}>
          <div style={{width: '100%', maxWidth: '950px'}}>
            <Poster >
              <h2 style={{marginTop: 0}}>{t("Whistleblower Scheme")}</h2>
              <PreviewBox style={{alignItems: 'center', width: '100%'}}>
                  <GrayLine width="50%" />
                  <div style={{width: '80%', display: 'flex', alignItems: 'center', gap: '20px'}}>
                    <GrayLine />
                    <GrayLine bg={activeChannel.primaryColor} width="40%" />
                  </div>
                  <GrayLine width="100%" />
                  <GrayLine width="80%" />
                  <GrayLine width="80%" />
              </PreviewBox>
              <div style={{margin: '20px 0'}}>
                <QRCodeSVG value={`${process.env.REACT_APP_WHISTLEBLOWING_URL}/channel/${activeChannel.channelId}`} size={250} />
              </div>

              <PreviewBox style={{alignItems: 'center', width: '100%'}}>
                  <GrayLine bg={activeChannel.primaryColor} width="80%" />
                  <GrayLine bg={activeChannel.primaryColor} width="50%" />
              </PreviewBox>
            </Poster>
          </div>
        </div>

      </Panel>}

      </PageContainer>

      { isAddNew && 
        <Overlay className={`popup`}>
          <Page className={`double`} style={{maxWidth: '700px!important'}}>
            <TopHeader className={`popup`}>
              <span>{t("Create New channel")}</span>
              <CloseButton onClick={closeModal}>
                <GetIcon icon={"Close"} />
              </CloseButton>
            </TopHeader>
            <FormMainContainer>
              <Customize>
          <FormGroup>
            <Label>Name</Label>
            <Input value={newData.channelName} onChange={(e) => setNewData((prev) => ({...prev, channelName: e.target.value}))} placeholder="Enter channel name" />
          </FormGroup>
          <FormGroup>
            <Label>Link suffix</Label>
            <div style={{ display: 'flex'}}>
                <PrefixSpan style={{display: 'inline-flex', backgroundColor: '#fbfbfbff', borderTopRightRadius: 0, borderBottomRightRadius: 0}} >{`${process.env.REACT_APP_WHISTLEBLOWING_URL}/channel/`}</PrefixSpan>
                <Input style={{width: '100%', flex: 1, borderTopLeftRadius: 0, borderBottomLeftRadius: 0}} value={newData.channelId} onChange={(e) => setNewData((prev) => ({...prev, channelId: e.target.value}))} />
            </div>
          </FormGroup>
        </Customize>
    
            <Footer>
              <FormInput type="close" value={t("cancel")} onChange={closeModal} />
              <FormInput disabled={submitDisabled} type="submit" name="submit" value={t("submit")} onChange={handleNewDataSubmit} />
            </Footer>
            </FormMainContainer>
          </Page>
        </Overlay>

      }
    </Container>
    {isUpdate && <div style={{position: 'fixed', bottom: 0, right: 0, border: '1px solid #d6e0ff',boxShadow: 'rgb(0 0 0 / 6%) 0px 0px 8px 7px' , display: 'flex',alignItems: 'center', gap: '10px', flexWrap: 'wrap', padding: '5px 20px', backgroundColor: '#FFFFFF'}}>
        <p>{t("Remember to save you changes")}</p>
        <Button onClick={() => fetchChannels()} style={{textAlign: 'center', borderRadius: '5px', margin: 0, padding: '10px 15px', fontSize: '16px', fontWeight: '600'}}>{t("cancel")}</Button>
        <Button onClick={handleUpdate} style={{textAlign: 'center', borderRadius: '5px', margin: 0, padding: '10px 15px', fontSize: '16px', fontWeight: '600' }}>{t("Save")}</Button>
      </div>
    }
    {isLoading && <Loader/>}
    </>
  );
};

export default withLayout(ReportingChannel);